import { Component, OnInit } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { Globals } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AdminDashboard } from 'src/app/shared/models/BasicData/AdminDashboard';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {
  statistic :AdminDashboard;

  constructor(public adminService: AdminService, public globals: Globals, translate: TranslateService, private router: Router) {

    // this.adminService.getAllStatistics();
    
    /*this.adminService.getAllStatistics().then((result: any) => {
      this.statistic = result;
    });*/
   
    
  }

  ngOnInit() {
  }
}
